import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import cat from "../../assets/footer_cat.svg";


const Title = styled.div`
    font-family: 'IBM Plex Mono', monospace;
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 40px;
    text-align: center;
`;

const SubTitle = styled.div`
    font-family: 'IBM Plex Mono', monospace;;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    margin-top: 24px;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.5;
`;

const Button = styled.a`
    font-family: 'IBM Plex Mono', monospace;;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    margin-top: 24px;
    text-align: center;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15px 16px;

    width: 373px;
  

    background: #FFFFFF;
    color: #000;
    text-transform: uppercase;
    text-align: center;
`;



// EarlyAccessFooter to display footer for creators to apply to glip.gg
export default function EarlyAccessFooter() {        
    
    return (
        <div 
            style={{
                marginTop: 150,
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: 40,
            }}>
            <img style={{width: 178}} src={cat} />
            <Title>Creator? Drop Stream Powers with us</Title>
            <SubTitle>Drop Power, live on stream.</SubTitle>
            <Button href="https://1yl3bb2gbfl.typeform.com/glipcreator?typeform-source=glip.gg" target="_blank">apply for early access</Button>
        </div>
    );
}


